export default __webpack_public_path__ + "static/umbrella-graphic-b84d89aca947b2647b2bc241c88cd04b.svg";